﻿import { fetchBaseQueryWrapper } from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

const TAG_TYPES = {
  baselineDates: "BaselineDates",
};

export const baselineDateApi = createApi({
  reducerPath: "baselineDateApi",
  baseQuery: fetchBaseQueryWrapper({
    path: "baselineDates",
  }),
  endpoints: (build) => ({
    getBaselineDates: build.query({
      query: () => "",
      transformResponse: ({ data }) => data,
      providesTags: [TAG_TYPES.baselineDates],
    }),
    getBaselineDate: build.query({
      query: ({ projectTypeId, baselineDateId }) =>
        `${projectTypeId}/${baselineDateId}`,
      transformResponse: ({ data }) => data,
      providesTags: [TAG_TYPES.baselineDates],
    }),
    saveBaselineDate: build.mutation({
      query: ({ projectTypeId, baselineDate }) => ({
        url: projectTypeId,
        method: "POST",
        body: { ...baselineDate },
      }),
      invalidatesTags: [TAG_TYPES.baselineDates],
    }),
    deleteBaselineDate: build.mutation({
      query: ({ projectTypeId, id }) => ({
        url: `${projectTypeId}/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted({ id }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            baselineDateApi.util.updateQueryData(
              "getBaselineDates",
              undefined,
              (baselineDates) =>
                baselineDates.filter((baselineDate) => baselineDate.id !== id)
            )
          );
        } catch {
          console.error("error deleting baseline date");
        }
      },
    }),
  }),
});

export const {
  useGetBaselineDatesQuery,
  useGetBaselineDateQuery,
  useSaveBaselineDateMutation,
  useDeleteBaselineDateMutation,
} = baselineDateApi;
